var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particles",attrs:{"aria-hidden":"true"}},_vm._l((_vm.particles),function(particle){return _c('span',{key:particle.id,staticClass:"particle",style:({
      left: particle.x + '%',
      top: particle.y + '%',
      width: particle.size + 'px',
      height: particle.size + 'px',
      opacity: particle.opacity,
      animationDuration: particle.duration + 's',
      animationDelay: particle.delay + 's',
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }